export default class Tabs {
    constructor(container) {
        this.container = container;
        if (this.container) {
            this.initTabs();
        }
    }
    initTabs() {
        const toggles = this.container.querySelectorAll('[data-tab-toggle]');
        const views = this.container.querySelectorAll('[data-tab-view]');
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const tabIndex = toggle.getAttribute('data-tab-toggle');
                // Remove active class from all toggles and views
                toggles.forEach(t => t.classList.remove('active'));
                views.forEach(v => v.classList.remove('active'));
                // Add active class to selected toggle and view
                toggle.classList.add('active');
                const targetView = this.container.querySelector(`[data-tab-view="${tabIndex}"]`);
                if (targetView) {
                    targetView.classList.add('active');
                }
            });
        });
    }
}
